import { FC } from "react";
import { Button } from "@chakra-ui/react";

import { Info2Icon } from "../../../../icons";
import { useAppModal } from "../../../Modals";
import { ForeignPassportInfoModal } from "./ForeignPassportInfoModal";
import { TRadioOption } from "../../../../../store/slices/passportFormSliceCreator";

interface Props {
  passportType: TRadioOption | null;
}

export const ForeignPassportInfo: FC<Props> = ({ passportType }) => {
  const { showModal } = useAppModal();

  const showInfoIcon = passportType === "PASSPORT_FOREIGN";

  const onClick = () => {
    showModal({
      content: onClose => <ForeignPassportInfoModal onClose={onClose} />,
    });
  };

  if (!showInfoIcon) {
    return null;
  }

  return (
    <Button
      minW="52px"
      p="0"
      position="absolute"
      top="0"
      right="0"
      colorScheme="transparent"
      onClick={onClick}
    >
      <Info2Icon />
    </Button>
  );
};
